module.exports = __webpack_public_path__ + "img/cartoon-dude-couch.cf90f2d1.jpg";